import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import BrandedLoader from '@/components/BrandedLoader';

export default function RequireAuth({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <BrandedLoader message="Loading..." />;
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  return <>{children}</>;
}
